import React from "react";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";

const Modal = ({ children, onClose }) => {
  return (
    <div className="">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="h-inner-height flex flex-col inset-0 z-20 md:w-1/3 w-2/3 md:h-2/3 md:overflow-y-auto sm:max-w-md m-auto outline-none focus:outline-none rounded-lg overflow-y-auto"
      >
        <div
          className="z-50 absolute rounded-full inline-block text-black p-8 bg-white shadow m-8 hover:shadow"
          onClick={onClose}
        >
          <AiOutlineClose />
        </div>
        {children}
        <div
          onClick={onClose}
          className="opacity-25 fixed inset-0 z-10 bg-black"
        />
      </div>
    </div>
  );
};

export default Modal;
